import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import LazyImportPlugin from "./lazyImport"

type Namespaces = [
  "app",
  "login",
  "phishing",
  "elearning",
  "homePage",
  "organization",
  "error401",
  "error404",
  "maintenance",
  "challenge",
  "learningPage",
  "tools",
  "licenceExpired",
  "starterLicence",
  "newAdminForm",
  "avatar",
  "library",
  "phishingAutomation",
  "reminder",
  "dashboard",
  "tatami",
  "home",
  "dojo",
  "components",
  "administration",
  "specialEvent",
]

const langs = ["en", "fr", "es", "de", "pt"]
const namespaces: Namespaces = [
  "app",
  "login",
  "phishing",
  "elearning",
  "homePage",
  "organization",
  "error401",
  "error404",
  "maintenance",
  "challenge",
  "learningPage",
  "tools",
  "licenceExpired",
  "starterLicence",
  "newAdminForm",
  "avatar",
  "library",
  "phishingAutomation",
  "reminder",
  "dashboard",
  "tatami",
  "home",
  "dojo",
  "components",
  "administration",
  "specialEvent",
]

i18n
  .use(LanguageDetector)
  .use(LazyImportPlugin)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "lang",
      convertDetectedLanguage: lng => lng.split("-")[0],
    },
    supportedLngs: langs,
    ns: namespaces,
    defaultNS: "app",
    load: "currentOnly",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: { useSuspense: true },
    missingKeyHandler: (lng, ns, key) => {
      console.error(`${ns} ${key} ${lng}`)
    },
  })

export default i18n
